import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProcessState } from '../reducers/process.reducers';

const applicationSteps = [0];
const applicantSteps = [4, 3, 2];
const outcomeSteps = [1, 5, 6];

export const selectProcessesState = createFeatureSelector<ProcessState>(
  'processes'
);

export const selectProcess = createSelector(
  selectProcessesState,
  state => state.process
);

export const selectApplicationSteps = createSelector(
  selectProcessesState,
  state =>
    state.process.steps.filter(
      step => applicationSteps.indexOf(step.type) !== -1
    )
);

export const selectApplicantSteps = createSelector(
  selectProcessesState,
  state =>
    state.process.steps.filter(step => applicantSteps.indexOf(step.type) !== -1)
);

export const selectOutcomeSteps = createSelector(
  selectProcessesState,
  state =>
    state.process.steps.filter(step => outcomeSteps.indexOf(step.type) !== -1)
);

export const selectStepById = id =>
  createSelector(
    selectProcessesState,
    state => state.process.steps.filter(step => step.id === id)[0]
  );
